import { css } from 'lit';

var css_248z = css`:host{--scatter-point-color:#858790;--scatter-highlight-color:#ff9b63;--scatter-axis-color:#858790;--scatter-tooltip-bg:#453838b8;--scatter-tooltip-text:#ff9b63;--scatter-tooltip-font-size:12px;display:block;width:100%}#ht-scatter-plot-chart svg{display:block;height:auto;width:100%}`;

export { css_248z as default };
//# sourceMappingURL=scatterPlotChart.styles.css.js.map
